import { AuthStore } from 'frontendcommon-3'
import AuthFarmapremium from './../farmapremium/Auth'
import NEXTERA_URLS from './../nextera/urls'

export default class Auth extends AuthFarmapremium {
  async getAuthData () {
    try {
      // get session data
      const tokenData = await this.fetchToken()
      if (!tokenData.token) return this.manageTokenError()
      let tokens = {
        farmapremium: {
          access_token: tokenData.access_token || tokenData.token,
          refresh_token: tokenData.refresh_token,
          expires: tokenData.token_exp
        },
        farmacloud: {
          jti: tokenData.farmacloud_jti
        }
      }
      tokens = await this.setRefreshToken(tokens, 'farmapremium')
      const { micros, sidebar, user } = await this.fetchShellConfig(tokenData.token)
      this.checkDashboardType(user.role)
      // create a common data structure
      const permissions = {}
      micros.forEach(element => {
        permissions[element.id] = true
      })
      const userData = {
        ...user,
        language: 'es',
        is_admin: user.role === 'adm1n',
        permissions
      }
      const authData = {
        isLogged: true,
        tokens,
        user: userData,
        micros,
        sidebar
      }
      // store only userData in localstorage
      AuthStore.storeUserData(userData)

      this.initExternalTools(authData)
      return authData
    } catch (error) {
      console.error(error)
      return this.manageTokenError()
    }
  }

  checkDashboardType (userType) {
    if (userType !== 'customer') {
      const event = new CustomEvent('hide-content')
      window.dispatchEvent(event)
      window.location.assign(NEXTERA_URLS.NEXTERA_BASE_URL)
    }
  }
}
